import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { PageLayout } from '@/components/pagelay';
import { getHead, getServerSideProps } from '@/utils/useHead';
import styles from './index.module.scss';
import HTMLFlipBook from 'react-pageflip';
import Head from 'next/head';
import { IndexContext } from '@/stores';
import { Checkbox, CheckboxGroup, Collapsible, Form, Toast } from '@douyinfe/semi-ui';
import classNames from 'classnames';
import useRequest from '@/utils/useRequest';
import { debounce, difference } from 'lodash';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/router';
interface IProps {

}
export { getServerSideProps }

export default ({ navDetail }: any) => {
  const [active, setActive] = useState(0)
  const { setIsBecome } = useContext(IndexContext);
  const formRef = useRef<any>()
  const checkbox = useRef<any>()
  const request = useRequest()
  const router = useRouter()
  const [isOpen, setIsOpen] = useState(false)
  const t = useTranslations();
  const [field, setField] = useState<any>([])
  const [cates, setCates] = useState<any>([])
  const [selectCates, setSelectCates] = useState<any>([])
  const [selectChildCates, setSelectChildCates] = useState<any>([])

  const btnClick = useCallback(() => {
    const { application_area_ids, ...params } = formRef.current.getFormState().values
    formRef.current.validate().then(async () => {
      const { data, msg } = await request.post('/addPurchase', {
        ...params,
        application_area_ids: application_area_ids.join(','),
        category_ids: [...selectCates, ...selectChildCates].join(',')
      })
      if (data.code == 200) {
        Toast.success({
          content: t('purchase.success'),
        })
        formRef.current.reset()
        return;
      } else {
        Toast.error({
          content: data.msg,
        })
      }

    }).catch((err: any) => {
      Toast.error({
        content: t('common.tips.all'),
        duration: 3,
      })
    })

  }, [selectCates, selectChildCates])

  const transOption = useCallback((arr: any = []) => {
    if (!arr.length) return []
    return arr?.map((item: any) => {
      return {
        // ...item,
        children: transOption(item.childlist),
        key: item.id,
        value: item.id,
        label: item?.[`name_${router.locale}`] || item.name
      }
    }).filter((item: any) => !!item.label)
  }, [router.locale])

  const filterUnique = (sourceArr, filterArr) => {
    const filterSet = new Set(filterArr);
    return sourceArr.filter(item => !filterSet.has(item));
  };

  const findNode = (source, filter) => {
    const filterSet = new Set(filter);
    //@ts-ignore
    const id = [...new Set(source)].filter(item => !filterSet.has(item))[0];

    return cates
      .find((item: any) => item.value == id)
      ?.children?.map(item => item.value)
  };

  const getFiled = useCallback((filed: string) => {
    return formRef.current.getValue(filed)
  }, [formRef.current])

  const getData = useCallback(async () => {
    const { data: _data } = await request.get('/getApplicationAreaList')
    setField(transOption(_data?.data))
    setCates(transOption(navDetail?.list))
  }, [router.locale])

  useEffect(() => {
    getData()
  }, [getData])

  return (
    <div className={styles.container}>
      {getHead(navDetail)}
      <div>
        <div className={styles.top}>
          <div className={styles.left}>
            <h1>{t('purchase.title1')}</h1>
            <p>{t('purchase.title2')}</p>
            <ul>
              <li>
                <h2>{t('purchase.advantage1')}</h2>
                <p>{t('purchase.advantage1-2')}</p>
              </li>
              <li>
                <h2>{t('purchase.advantage2')}</h2>
                <p>{t('purchase.advantage2-2')}</p>
              </li>
              <li>
                <h2>{t('purchase.advantage3')}</h2>
                <p>{t('purchase.advantage3-3')}</p>
              </li>
            </ul>
          </div>
          <div className={styles.right}>
            <div className={styles.shape}>
              <img src="/image/purchase-shape.png" alt="" />
              <div className={classNames({ [styles.enSpan]: router.locale === 'en' })}>
                <span className={styles.tag}>{t('purchase.consultant')}</span>
                <p>{router.locale === 'cn' && '粉小姐'} Miss.Powder</p>
                <span>{t('purchase.contact1')}</span>
              </div>
            </div>
            <img src="/image/engineer.png" alt="" />
          </div>
        </div>

        <div className={styles.form}>
          <Form
            getFormApi={(formApi: any) => formRef.current = formApi}
            labelPosition="top"
          >
            {
              (({ formState, values, formApi }) => (
                <div className={styles.box}>
                  <div className={styles.tips}>
                    <p className={styles.title}>{t('purchase.tipTitle')}</p>
                    <ul>
                      <li><span>1</span>{t('purchase.tip1')}</li>
                      <li><span>2</span>{t('purchase.tip2')}</li>
                      <li><span>3</span>{t('purchase.tip3')}</li>
                    </ul>
                  </div>
                  <div className={styles.type}>
                    <h3 style={{ marginBottom: '20px' }}>{t('purchase.type')}</h3>
                    <CheckboxGroup className='type' onChange={(checkedValues) => {
                      if (checkedValues.length < cates.length) {
                        setSelectChildCates(filterUnique(selectChildCates, findNode(selectCates, checkedValues)))
                      }
                      setSelectCates(checkedValues)
                    }}>
                      {
                        cates?.map((item: any) => (
                          <div key={item.id}>
                            <Checkbox value={item.value}>
                              <p style={{ marginBottom: '6px' }}>{item.label}</p>
                            </Checkbox>
                            {
                              !!item.children?.length &&
                              selectCates.includes(item.value) &&
                              <CheckboxGroup
                                style={{ marginLeft: '20px' }}
                                options={item.children}
                                onChange={(checkedValues) => {
                                  setSelectChildCates(checkedValues)
                                }}
                              />
                            }
                          </div>
                        ))
                      }
                    </CheckboxGroup>
                  </div>
                  <div className={styles.filed}>
                    <h3>{t('purchase.filed')}</h3>
                    <Form.CheckboxGroup
                      className='filed'
                      field='application_area_ids'
                      options={field}
                      noLabel
                    />
                  </div>
                  <div className={styles.words}>
                    <h3 className={styles.required}>{t('purchase.content')}</h3>
                    <p style={{ fontSize: '14px' }}>{t('purchase.tip4')}</p>
                    <Form.TextArea
                      field="content"
                      placeholder={t('purchase.contentPlaceholder')}
                      noLabel
                      trigger='blur'
                      style={{ height: '200px' }}
                      rules={[
                        { required: true, message: t('become.tips.required') },
                      ]}
                    />
                    <div className={styles.grid}>
                      <Form.Input
                        field="truename"
                        placeholder={t('purchase.namePlaceholder')}
                        label={(<span className={styles.required}>{t('purchase.name')}</span>)}
                        trigger='blur'
                        rules={[
                          { required: true, message: t('become.tips.required') },
                        ]}
                      />
                      <Form.Input
                        field="mobile"
                        placeholder={t('purchase.mobilePlaceholder')}
                        label={(<span className={styles.required}>{t('purchase.mobile')}</span>)}
                        trigger='blur'
                        rules={[
                          { required: true, message: t('become.tips.required') },
                        ]}
                      />
                      <Form.Input
                        field="email"
                        placeholder={t('purchase.emailPlaceholder')}
                        label={(<span className={styles.required}>{t('purchase.email')}</span>)}
                        trigger='blur'
                        rules={[
                          { required: true, message: t('become.tips.required') },
                        ]}
                      />
                      <Form.Input
                        field="position"
                        placeholder={t('purchase.positionPlaceholder')}
                        label={(<span className={styles.required}>{t('purchase.position')}</span>)}
                        trigger='blur'
                        rules={[
                          { required: true, message: t('become.tips.required') },
                        ]}
                      />
                      <Form.Input
                        field="company"
                        placeholder={t('common.placeholder.company')}
                        label={(<span className={styles.required}>{t('become.companyName')}</span>)}
                        trigger='blur'
                        rules={[
                          { required: true, message: t('become.tips.required') },
                        ]}
                      />
                    </div>
                  </div>
                </div>

              ))
            }
          </Form>

          <div className={styles.footer}>
            <div className={styles.btns}>
              <div className={styles.subBtn} onClick={debounce(() => btnClick(), 500)}>{t('become.submit')}</div>
            </div>
          </div>
        </div>
      </div>
      <style jsx global>
        {
          `
          .filed{
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(285px, 1fr));
          }
          .type{
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(468px, 1fr));
            gap:20px 0;
          }
            .semi-tree-select-selection .semi-tag{
              height:34px !important;
            }
            .semi-table-row,
            .semi-table-row-cell{
              height:80px;
              border-bottom:none;
            }
            .semi-page-item{
              font-size:16px;
              color: #333;
              margin:0 5px;
            }
            .semi-page-item:hover{
              background-color:#eaf3ee;
            }
            .semi-page-item-active{
              color:white !important;
              background:#6354a2 !important;
              border:none !important;
            }
            .semi-modal-header{
              border-bottom: 1px solid #ddd;
              padding-bottom: 30px;
            }
            .semi-modal-title{
              color:#094020;
              font-size:24px !important;
              font-weight:500 !important;
            }
            .semi-dropdown-item{
              justify-content:center;
            }
            .semi-form-field-label-text::after {
              display: none;
            }
            .semi-input-textarea{
              height:100%;
            }
            .semi-radioGroup{
              min-height: 50px;
              align-items: center;
            }
            .semi-tree-option {
              padding: 8px 12px !important;
            }
            .semi-form-field-label {
              font-weight: 500;
              padding-right: 20px;
              font-size: 16px;
              display:flex;
              align-items:flex-start;
              justify-content:right;
              margin-top:8px;
            }
            .semi-form-slot .semi-form-field-label{
              margin-top: 0px;
  
            }
            .custom .semi-form-field-label-text{
              margin-top:10px;
            }
            .semi-input-wrapper,
            .semi-select,
            .semi-tree-select {
              width: 100%;
              background: white;
              height: 56px;
              line-height: 56px;
              border: 1px solid #ddd;
              border-radius: 4px;
            }
            .semi-input-textarea-wrapper {
              width: 100%;
              background: white !important;
              border: 1px solid #ddd;
              border-radius: 4px;
              padding-top:10px;
            }
            .semi-input-wrapper:hover,
            .semi-select:hover,
            .semi-tree-select:hover {
              border: 1px solid #6354a2;
            }
            .semi-form-field {
              padding: 14px 0;
            }
            .semi-radioGroup{
              padding:0 !important;
            }
            .semi-radio-inner,
            .semi-radio-inner-display,
            .semi-checkbox-inner,
            .semi-checkbox-inner-display {
              width: 18px !important;
              height: 18px !important;
              background: white;
            }
            .semi-checkbox-checked .semi-checkbox-inner-display{
              border-style: #6354a2 !important;
              background: #6354a2 !important;
              box-shadow: none;
            }
            .semi-radio-checked .semi-radio-inner-display{
              border: 2px solid #6354a2 !important;
              background: white !important;
            }
            .semi-radio-inner-display .semi-icon{
              color: #6354a2;
              transform: scale(1.2) translate(-2px, -2px);
            }
            .semi-radio:hover .semi-radio-inner-display{
              border: 2px solid #6354a2 !important;
            }
            .is-check .semi-checkbox-inner-display,
            .is-check .semi-checkbox-inner-display:hover {
              background: white !important;
              // box-shadow: none;
            }
            .is-check .semi-checkbox-inner-checked span{
              background: #6354a2 !important;
              overflow:hidden;
            }
            .semi-icon-default {
              font-size: 18px !important;
            }
            .semi-input-wrapper-disabled,
            .semi-select-disabled{
              background-color:#f3f5f9;
            }
            .slot .semi-form-field-label {
              display: none !important;
            }
            .semi-form-slot .semi-form-field {
              padding: 0 !important;
            }
            .semi-input-number {
              width: 100%;
            }
            .semi-table-container{
              margin-bottom: 20px;
            }
            .semi-table-cell-fixed-right-first{
              border-left:none !important;
            }
            .semi-checkbox-indeterminate .semi-checkbox-inner-display{
              background:#6354a2;
              box-shadow: 0 0 0 1px #6354a2;
            }
            .semi-table-row-head{
              color:#999 !important;
              white-space: nowrap;
            }
            @media screen and (max-width: 887px) {
              .semi-form-field-label {
                justify-content: left !important;
                padding:0 0 20px !important;
                margin-top:0;
              }
              .semi-form-field {
                flex-direction: column;
                padding-top: 0 !important;
              }
              .type{
                grid-template-columns: 1fr !important;
              }
              .semi-form-field-label-text{
                white-space:nowrap;
              }
            }
          `
        }
      </style>
    </div>
  );
};


